<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="form">
					<c-form-item type="datetime" label="变化时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="input" label="用户名" name="login_name"></c-form-item>
					<c-form-item type="select" label="收支类型" name="income_expenses" :options="state"></c-form-item>
				</c-form>
			</m-search>

            <m-operate>
                <c-button @click="exportData()" power="b_points_recort_export">导出</c-button>
            </m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="变化时间"
					name="create_date"
					width="140"
				></c-table-column>

        <c-table-column
            label="收支类型"
            name="income_expenses"
        >
          <template v-slot="{data}">
            <span v-if="data.income_expenses == 1" style="color:green">收入</span>
            <span v-if="data.income_expenses == 2" style="color:red">支出</span>
          </template>
        </c-table-column>

				<c-table-column
					label="积分"
					name="points"
				>
					<template v-slot="{data}">
              <span v-if="data.income_expenses == 1" style="color:green"> + {{data.points}}</span>
              <span v-if="data.income_expenses == 2" style="color:red"> - {{data.points}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="用户"
					name="login_name"
				></c-table-column>
				
				<c-table-column
					label="详细说明"
					name="remark"
					width="500"
				></c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_points_recort',
		
		data() {
			return {
				state: [{
					name: '收入',
					value: 1
				}, {
					name: '支出',
					value: 2
				}]
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/points_card/list',
					data
				});
			},

            exportData(){
                var exportData = this.$refs.form.serialize();
                exportData.job_id = 37;
                exportData.create_system = 'OMS';

                this.request({
                    url: '/export_job/add',
                    data: exportData,
                    success: data => {
                        this.$message({
                            text: '导出任务创建成功，请前往任务中心查看导出进度',
                            icon: 'success'
                        });
                    }
                });
            }
		}
	}
</script>